import {
  ProductOptionToCollect,
  productOptionToCollectFromResponse,
} from './ProductOptionToCollect';
import { OrderProduct } from '../Order/OrderProduct';

export interface ProductToCollect {
  id?: number;
  name: string;
  barcode?: string;
  options: ProductOptionToCollect[];
  quantity: number;
}

export const productToCollectFromResponse = (
  responseData: any,
): ProductToCollect => ({
  id: responseData.id,
  name: responseData.name,
  barcode: responseData.barcode,
  options: (responseData.options ?? []).map(productOptionToCollectFromResponse),
  quantity: responseData.quantity,
});

export const productToCollectFromOrderProduct = (
  orderProduct: OrderProduct,
): ProductToCollect => ({
  id: orderProduct.productID,
  name: orderProduct.name.name,
  barcode: orderProduct.barcode,
  options: orderProduct.options,
  quantity: orderProduct.quantity,
});
